import { parse, isValid } from 'date-fns'
import { z } from 'zod'

import { Status } from './status.enum'

function isISODate (value: string): boolean {
  let valid = false

  try {
    valid = isValid(parse(value, 'yyyy-MM-dd', new Date()))
  } catch (err) {}

  return valid
}

export let providerSchema = z.object({
  id: z.string(),

  name: z.string()
    .nullable()
    .optional(),

  provider_key: z.string()
    .nullable()
    .optional(),

  claims: z.number()
    .nullable()
    .optional(),

  first_claim_date: z.string()
    .refine(isISODate)
    .nullable()
    .optional(),

  last_claim_date: z.string()
    .refine(isISODate)
    .nullable()
    .optional(),

  places_of_service: z.array(
    z.string()
      .nullable()
      .optional()
  )
    .nullable()
    .optional(),

  status: z.nativeEnum(Status)
    .nullable()
    .optional(),

  likely_resource_type: z.string()
    .nullable()
    .optional()
})

export let providersSchema = z.array(providerSchema)
